import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default function layoutHOC(WrappedComponent, LayoutComponent) {
  return class extends PureComponent {
    static propTypes = {
      embeddable: PropTypes.bool,
      ax: PropTypes.bool,
    };

    static defaultProps = {
      embeddable: false,
      ax: false,
    };

    render() {
      return (
        !this.props.ax && this.props.embeddable ?
          <WrappedComponent {...this.props} />
          :
          <LayoutComponent {...this.props}>
            <WrappedComponent {...this.props} />
          </LayoutComponent>
      );
    }
  };
}
